/**
 * @generated SignedSource<<6468a1fe533f5fd8634b23ce116f86b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RenameBaselineVersionInput = {
  projectId: string;
  baselineVersionId: string;
  name: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type RenameBaselineVersionMutation$variables = {
  input: RenameBaselineVersionInput;
};
export type RenameBaselineVersionMutation$data = {
  readonly renameBaselineVersion: {
    readonly project: {
      readonly id: string;
      readonly baselineVersions: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null;
      }> | null;
    } | null;
  } | null;
};
export type RenameBaselineVersionMutation = {
  variables: RenameBaselineVersionMutation$variables;
  response: RenameBaselineVersionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RenameBaselineVersionPayload",
    "kind": "LinkedField",
    "name": "renameBaselineVersion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BaselineVersion",
            "kind": "LinkedField",
            "name": "baselineVersions",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RenameBaselineVersionMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RenameBaselineVersionMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "12c57566e558b59d09699f66f5b6e891",
    "id": null,
    "metadata": {},
    "name": "RenameBaselineVersionMutation",
    "operationKind": "mutation",
    "text": "mutation RenameBaselineVersionMutation(\n  $input: RenameBaselineVersionInput!\n) {\n  renameBaselineVersion(input: $input) {\n    project {\n      id\n      baselineVersions {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0b864cc98a2a3e350761f54f7b43095a";

export default node;
